var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampingSquirrelGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5,
    cy: 42.4826,
    rx: 42.5,
    ry: 42.4826,
    fill: "#D3D3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0103 47.8852C28.8791 46.9121 31.8107 50.6578 32.2929 52.6522C35.6151 61.0328 35.9894 70.5419 35.1373 75.688C28.4341 76.0239 31.1386 76.7403 25.7773 77.009C24.4368 77.0761 23.7054 69.9328 16.9688 70.2947C12.5749 70.5307 9.2351 68.0295 8.20098 64.0404C7.16686 60.0513 11.1743 49.1016 21.0103 47.8852Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.634 60.3677C37.0671 59.7334 24.5253 76.2259 22.2778 79.0011C33.3831 87.3266 58.37 87.7231 69.8719 74.2436C67.3335 70.1205 58.0614 59.0462 55.1529 59.1783C57.3739 52.835 63.614 48.6062 66.6548 46.8882L36.5118 51.6457C43.4923 53.8658 46.1629 57.8568 45.634 60.3677Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7525 19.1362C34.6081 19.4533 36.6441 21.3827 37.3051 22.3078L34.5288 27.0653C32.5457 27.5939 28.5795 27.9375 28.5795 25.083C28.5795 22.2285 27.5219 20.4577 26.9931 19.9291C27.3897 19.5326 28.8968 18.819 31.7525 19.1362Z",
    fill: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2751 12C61.1022 12.6343 59.2513 15.9646 58.7225 17.5504L61.4988 20.3256C62.4242 19.797 64.4338 18.264 65.0683 16.361C65.7029 14.458 64.8039 12.6608 64.2751 12Z",
    fill: "#464646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7726 20.5408C31.4869 24.0908 30.1655 34.9291 30.1655 39.9044C38.094 44.7454 57.6952 40.5768 67.3306 37.8874C67.3306 35.7359 68.5694 32.2397 68.1565 27.3987C67.8767 24.1189 62.9258 19.0616 60.7234 16.9101C56.181 14.893 43.3797 16.1033 36.7726 20.5408Z",
    fill: "#464646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.098 22.7041C33.6559 26.1929 32.0165 36.58 31.7521 41.3375C41.9055 42.9233 48.41 39.3552 50.3931 37.3729C47.2202 23.7349 40.8743 21.9112 38.098 22.7041Z",
    fill: "#8C8C8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5153 26.6688C59.5153 29.5233 62.9527 33.6728 64.6714 35.3908C66.2578 34.5979 70.224 33.805 68.6375 28.2546C67.3684 23.8143 63.3493 19.5326 61.4984 17.9468C59.912 18.7397 59.5153 23.1007 59.5153 26.6688Z",
    fill: "#8C8C8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0807 38.959C41.6672 38.959 46.8232 38.1661 49.203 37.7696C51.7149 37.5053 57.294 36.7388 59.515 35.7873C62.2913 34.598 69.0338 33.0121 70.6203 34.2015C72.2068 35.3909 73 36.5802 73 39.3554C73 42.1306 69.8271 45.3023 67.0507 46.8881C64.2744 48.4739 61.4981 48.4739 60.3082 48.4739C59.3564 48.4739 58.0607 49.5311 57.5319 50.0597C51.186 54.0243 49.9962 53.6278 40.874 52.8349C31.7518 52.042 28.5788 47.2845 27.7856 44.5094C26.9924 41.7342 28.1822 39.3554 30.1653 38.5625C32.1484 37.7696 38.0977 38.959 40.0807 38.959Z",
    fill: "#464646"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3197 50.7446C61.957 48.6686 62.0669 44.4013 61.7922 42.5271C60.8032 43.5651 56.1603 44.1129 53.9625 44.2571C53.9625 45.1221 56.023 53.3396 59.3197 50.7446Z",
    fill: "#F9F7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0132 38.166C48.3305 36.5802 50.9217 35.7873 51.9793 35.7873C55.0201 35.3909 61.025 34.1221 62.2942 33.805C63.8807 33.4085 63.0991 45.1685 59.1214 45.6987C53.1722 46.4916 47.6166 40.1483 48.0132 38.166Z",
    fill: "#8C8C8C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1187 38.999C59.7533 38.6818 61.234 35.6952 61.895 34.2415C57.4529 32.9729 53.1695 34.7701 51.583 35.8273C53.6983 36.8846 58.1668 38.999 59.1187 38.999Z",
    fill: "#222222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.476 32.3135C45.5241 29.7762 43.5231 29.6818 41.3199 29.9348C38.2424 30.2882 36.1639 32.71 36.5605 36.2781C36.8778 39.1326 40.7176 39.7112 43.303 38.6568C45.8685 37.6107 47.4278 34.8509 46.476 32.3135Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6134 28.519C68.8711 26.4046 66.0237 25.876 64.6718 26.2725C63.4819 29.8405 65.7469 33.2177 67.4481 33.8051C69.0346 33.8051 70.3558 30.6334 69.6134 28.519Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6681,
    cy: 34.9945,
    rx: 1.18985,
    ry: 1.18937,
    fill: "#C4C4C4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0512,
    cy: 29.4439,
    rx: 1.98309,
    ry: 1.98228,
    fill: "#222222"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.0645,
    cy: 34.5979,
    rx: 3.17294,
    ry: 3.17164,
    fill: "#222222"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8572,
    cy: 33.8051,
    rx: 0.793235,
    ry: 0.792911,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8443,
    cy: 28.6511,
    rx: 0.396618,
    ry: 0.396456,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7225 47.6809V51.6455",
    stroke: "#464646",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7122 84.9477C41.7388 79.0345 46.6229 67.517 50.8344 66.3142C55.8479 64.8824 61.9397 72.261 64.3194 79.0008C64.3194 79.0008 61.5431 81.3796 54.404 83.3619C47.2648 85.3441 41.7122 84.9477 41.7122 84.9477Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampingSquirrelGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CampingSquirrel-gray.a04c0b1a55ce28006b8874d9720331df.svg";